import React from 'react'
import Footer from './Footer';
import Hero from './namaste/Hero';
import Section1 from './namaste/Section1';
import Section2 from './namaste/Section2';
import Section3 from './namaste/Section3';
import Section4 from './namaste/Section4';
import Section5 from './namaste/Section5';

const Namaste = () => {
  return (
    <>
        <Hero />
        <Section2 />
        <Section1 />
        <Section3 />
        <Section4 />
        <Section5 />
        <Footer />
    </>
  )
}

export default Namaste